import type { SVGProps } from 'react';
export const Happy = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 49 48" {...props}>
    <path
      fill="#4EA14E"
      d="M24.5 7.2a16.8 16.8 0 1 0 0 33.6 16.8 16.8 0 0 0 0-33.6m0 31.02a14.22 14.22 0 1 1 0-28.44 14.22 14.22 0 0 1 0 28.44m-7.75-17.45a1.94 1.94 0 1 1 3.87 0 1.94 1.94 0 0 1-3.87 0m15.5 0a1.94 1.94 0 1 1-3.87 0 1.94 1.94 0 0 1 3.87 0m-.17 7.75a8.6 8.6 0 0 1-7.58 4.53 8.6 8.6 0 0 1-7.58-4.53 1.3 1.3 0 1 1 2.24-1.29 6.04 6.04 0 0 0 10.68 0 1.3 1.3 0 0 1 2.24 1.3"
    />
  </svg>
);
